import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {TriggerFilters} from '../model/filters/trigger-filters';
import {TriggerPersistRequest} from '../model/requests/trigger-persist-request';
import {Trigger} from '../model/trigger';

@Injectable({
  providedIn: 'root'
})
export class TriggersService {

  private readonly triggersURL: string;

  constructor(private http: HttpClient) {
    this.triggersURL = "/catalog/triggers";
  }

  public getTriggers(offset?: number, limit?: number, filters?: TriggerFilters): Observable<any>{
    let options: {
      headers: HttpHeaders,
      params: any
    } = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body: TriggerFilters = filters ?? new TriggerFilters();
    return this.http.post<any>(this.triggersURL, body, options);
  }

  public getTrigger(entityType: string, entityUuid: string, entityMeasurementUuid: string, triggerName: string): Observable<any> {
    let url: string = `${this.triggersURL}/${entityType}/${entityUuid}/${entityMeasurementUuid}/${triggerName}`;
    return this.http.get<any>(url);
  }

  public createTrigger(persistData: TriggerPersistRequest): Observable<any> {
    let url: string = `${this.triggersURL}/create`;
    return this.http.post<any>(url, persistData);
  }

  public editTrigger(persistData: TriggerPersistRequest): Observable<any> {
    let url: string = `${this.triggersURL}/edit`;
    return this.http.post<any>(url, persistData);
  }

  public deleteTrigger(entityType: string, entityUuid: string, entityMeasurementUuid: string, triggerName: string): Observable<HttpResponse<any>> {
    let url: string = `${this.triggersURL}/${entityType}/${entityUuid}/${entityMeasurementUuid}/${triggerName}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteTriggers(identifiers: {
    entityType: string,
    entityUuid: string,
    entityMeasurementUuid: string,
    triggerName: string
  }[]): Observable<HttpResponse<any>> {
    let url: string = `${this.triggersURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

  public updateTriggerState(triggers: Trigger[], newActiveState: boolean): Observable<any> {
    let options: { headers: HttpHeaders, params: any } = HttpUtils.buildOptions({newActiveState: newActiveState});
    let url: string = `${this.triggersURL}/update_state`;
    return this.http.post<any>(url, triggers, options);
  }

  //TODO COMPROBAR EL END-POINT, MODIFICAR SI ES NECESARIO
  public importTriggersFromCsv(files: File[], tenant: string, organization?: string): Observable<any> {
    const url: string = `${this.triggersURL}/import/tenants/${tenant}`;
    const organizationUrl = organization !== undefined ? `/organizations/${organization}` : '';

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));

    return this.http.post<void>(url + organizationUrl, formData);
  }

}
